// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__37uk0","location":"Header_location__2O03m"};